import { IPhone } from './IPhone.model';
import { IEmail } from './IEmail.model';
import { ISaveScheduleDay } from './ISaveScheduleDay.model';

export class SaveCompanyContact {
    CompanyContactId: number;
    IsDefault: boolean | undefined;
    FirstName: string | undefined;
    LastName: string | undefined;
    NickName: string | undefined;
    Title: string | undefined;
    TimeZoneId: number | undefined;
    UpdatedPhones: IPhone[] | undefined;
    DeletedPhones: number[] | undefined;
    UpdatedEmails: IEmail[] | undefined;
    DeletedEmails: number[] | undefined;
    UpdatedSchedules: ISaveScheduleDay[] | undefined;
    DeletedSchedules: number[] | undefined;
}



// WEBPACK FOOTER //
// ./src/app/models/SaveCompanyContact.model.ts